import React from 'react'
import { ConfigProvider, Spin } from 'antd'
import { connect } from 'react-redux'

import korea from 'antd/locale/ko_KR'
import english from 'antd/locale/en_US'
import french from 'antd/locale/fr_FR'
import russian from 'antd/locale/ru_RU'
import chinese from 'antd/locale/zh_CN'
import japanese from 'antd/locale/ja_JP'

import i18n from 'i18n'

const locales = {
  'ko-KR': korea,
  'en-US': english,
  'fr-FR': french,
  'ru-RU': russian,
  'zh-CN': chinese,
  'ja-JP': japanese,
}

export const antdLocales = locales

@connect(({ settings }) => ({ settings }))
class Localization extends React.Component {
  state = {
    localeInitialized: false,
  }

  componentDidMount() {
    const { dispatch } = this.props
    const initLocale = () => {
      this.state.localeInitialized = true
      dispatch({
        type: 'settings/SET_LOCALE',
        payload: {
          locale: i18n.language,
        },
      })
    }
    if (i18n.isInitialized === true) {
      initLocale()
    } else {
      i18n.on('initialized', () => {
        initLocale()
      })
    }
  }

  render() {
    const { localeInitialized } = this.state
    const {
      children,
      settings: { locale },
    } = this.props

    const currentLocale = locales[locale]

    const customLocale = {
      ...currentLocale,
      DatePicker: {
        ...currentLocale.DatePicker,
        locale: 'ko',
        lang: {
          ...currentLocale.DatePicker.lang,
          weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
        },
      },
    }

    const component =
      localeInitialized === true ? (
        <ConfigProvider locale={customLocale}>{children}</ConfigProvider>
      ) : (
        <Spin />
      )

    return component
  }
}

export function isAvailable(locale) {
  return locales[locale] != null
}

export function getAvailableLocale(localeStr) {
  const str = localeStr
  const val = Object.keys(locales).find((locale) => {
    return locale.indexOf(str) === 0
  })

  return val || 'en-US'
}

export default Localization
